import { Injectable, Injector } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { ClusterModel, IClusterModel } from './cluster.model';
import { CoreParameterModel } from '@fi-shared/models';
import { IItemsListDataFetchResult } from '@fi-shared/fi-items-list/fi-items-list';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';

@Injectable()
export class ClusterService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
        private injector: Injector,
    ) {}

    GetCluster(id, contentLanguages?) {
        return new Promise<ClusterModel>((resolve, reject) => {
            if (id > 0) {
                this.fiBackend.fetchData<IClusterModel>(`Core/Cluster/GetCluster/${id}`).then((response) => {
                    resolve(new ClusterModel(response, this.injector));
                }, reject);
            } else {
                resolve(new ClusterModel(undefined, this.injector));
            }
        });
    }

    SaveCluster(cluster: ClusterModel) {
        return this.fiBackend.fetchDataPost('Core/Cluster/SaveCluster', cluster);
    }

    getClustersListData(parameter: CoreParameterModel) {
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<IClusterModel>>(
            'Core/Cluster/GetClustersListData',
            parameter,
        );
    }

    deleteClusters(clusterIdsToDelete: number[]) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<void>('Core/Cluster/DeleteClusters', clusterIdsToDelete),
        );
    }
}
